import React from "react";

export function MaterialNamesList({node, property, isTopNode, setSelected}) {
    const materials = node.ModelData.materialNames;
    return (
        <div className="model-preview-info-block">
            {materials?.length > 0 && (
                <div className="materials">
                    <ul>
                        {materials
                            .map(materialName => {
                                const foundMaterialNode = APP.sceneNode.findMaterialJson(materialName);
                                return (
                                    <li key={materialName}>
                                        {foundMaterialNode ? (
                                            <div className="button"
                                                 onClick={() => {
                                                     setSelected(foundMaterialNode, APP.sceneNode.getMaterialJsonProperty());
                                                 }}>
                                                {materialName}
                                            </div>
                                        ) : (
                                            <div>
                                                {materialName}
                                            </div>
                                        )}
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            )}
        </div>
    );
}
